export class PaymentInfoModel {
  devoluciones: [];
  monto: number;
  paymentId: number;
  saldo: string;
  sumDevoluciones: number;

  constructor() {
    this.devoluciones = [];
    this.monto = 0;
    this.paymentId = 0;
    this.saldo = '$0,00';
    this.sumDevoluciones = 0;
  }
}
